const CancelledInstantIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4L20 20"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 9V16C3 17.6569 4.34315 19 6 19H14"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5H18C19.6569 5 21 6.34315 21 8V15"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DateIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="14.584"
      cy="13.75"
      rx="3.75"
      ry="3.75"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83398 8.33335H9.16732"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25065 1.66669V4.16669"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7507 1.66669V4.16669"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33333 16.6667H5C3.61929 16.6667 2.5 15.5474 2.5 14.1667V5.41669C2.5 4.03598 3.61929 2.91669 5 2.91669H15C16.3807 2.91669 17.5 4.03598 17.5 5.41669V7.50002"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83398 11.6667H6.66732"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4941 12.486V13.9473L15.646 14.65"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UniqueIdIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.40786 6.79917C9.14009 7.53141 9.14009 8.71859 8.40786 9.45082C7.67562 10.1831 6.48844 10.1831 5.75621 9.45082C5.02397 8.71859 5.02397 7.53141 5.75621 6.79917C6.48844 6.06694 7.67562 6.06694 8.40786 6.79917"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.66602 15.4167V4.61752C1.66602 3.67835 2.42768 2.91669 3.36685 2.91669H16.666C17.5868 2.91669 18.3327 3.66252 18.3327 4.58335V15.4167C18.3327 16.3375 17.5868 17.0834 16.666 17.0834H3.33268C2.41185 17.0834 1.66602 16.3375 1.66602 15.4167Z"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 7.91667H15.8333"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 11.25H12.5"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0776 13.75C9.93177 13.3842 9.70677 13.0559 9.4176 12.7884V12.7884C8.92844 12.335 8.28677 12.0834 7.6201 12.0834H6.54344C5.87677 12.0834 5.2351 12.335 4.74594 12.7884V12.7884C4.45677 13.0559 4.23177 13.3842 4.08594 13.75"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ClockIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1941 2.55585C14.9587 3.19037 17.6449 6.55278 17.4325 10.3645C17.2202 14.1762 14.177 17.2194 10.3653 17.4317C6.55357 17.6441 3.19116 14.9579 2.55664 11.1933"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5549 8.69419C2.63286 8.22978 2.7548 7.77384 2.91906 7.33252"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16323 4.16498C4.79926 4.46561 4.4647 4.80017 4.16406 5.16415"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.6937 2.55582C8.22925 2.63396 7.7733 2.75618 7.33203 2.92082"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 10.4166H10.416V5.83331"
      stroke="#0A1326"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChatIcon = () => (
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0015 4.1636C6.44375 4.1636 2.74805 7.24368 2.74805 11.0388C2.81694 13.3289 4.07997 15.4158 6.07693 16.539C5.87857 17.078 5.60274 17.5853 5.25814 18.0449C5.06794 18.3226 5.07264 18.6898 5.26989 18.9625C5.46715 19.2353 5.81444 19.3547 6.13773 19.2611C7.24033 18.94 8.27814 18.4283 9.20407 17.749C9.79673 17.8601 10.3985 17.9153 11.0015 17.914C15.5592 17.914 19.2549 14.8339 19.2549 11.0388C19.2549 7.24369 15.5592 4.1636 11.0015 4.1636Z"
      stroke="black"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 9.66592H13.7523"
      stroke="black"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 12.4171H11.0011"
      stroke="black"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Circles = () => (
  <svg
    width="117"
    height="67"
    viewBox="0 0 117 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="6"
      cy="6"
      r="6"
      transform="matrix(-1 0 0 1 63 11)"
      fill="#FFB5FD"
    />
    <g opacity="0.4" filter="url(#filter0_f_6947_8706)">
      <circle
        cx="3.5"
        cy="3.5"
        r="3.5"
        transform="matrix(-1 0 0 1 9 2)"
        fill="#FFB5FD"
      />
    </g>
    <g opacity="0.4" filter="url(#filter1_f_6947_8706)">
      <circle
        cx="3"
        cy="3"
        r="3"
        transform="matrix(-1 0 0 1 113 57)"
        fill="#FFB5FD"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_6947_8706"
        x="0"
        y="0"
        width="11"
        height="11"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1"
          result="effect1_foregroundBlur_6947_8706"
        />
      </filter>
      <filter
        id="filter1_f_6947_8706"
        x="103"
        y="53"
        width="14"
        height="14"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_6947_8706"
        />
      </filter>
    </defs>
  </svg>
);

const HeartIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6562 10.6232H21.2536"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.0031 15H12.6562"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6563 19.3768H13.7505"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2513 26.2547H9.9987C6.54548 26.2547 3.74609 23.4553 3.74609 20.0021V9.9979C3.74609 6.54469 6.54548 3.7453 9.9987 3.7453H20.0029C23.4561 3.7453 26.2555 6.54469 26.2555 9.9979V15"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.2974 25.6494C23.9092 26.0373 23.3829 26.255 22.8342 26.2547V26.2547C22.2856 26.2547 21.7594 26.037 21.3711 25.6494L18.8851 23.1684C17.8966 22.1471 17.9099 20.5217 18.9149 19.5167C19.92 18.5117 21.5453 18.4984 22.5666 19.4869L22.8292 19.7482L23.0918 19.4869C24.1132 18.4984 25.7385 18.5117 26.7436 19.5167C27.7486 20.5217 27.7619 22.1471 26.7734 23.1684L24.2974 25.6494Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.13573 14.6874C8.96323 14.6881 8.82389 14.8283 8.82435 15.0008C8.82481 15.1733 8.9649 15.3128 9.13739 15.3126C9.30989 15.3124 9.44961 15.1725 9.44961 15C9.44994 14.9168 9.41694 14.8369 9.35797 14.7781C9.299 14.7194 9.21896 14.6867 9.13573 14.6874"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.13573 10.3105C8.96323 10.3112 8.82389 10.4515 8.82435 10.624C8.82481 10.7965 8.9649 10.936 9.13739 10.9358C9.30989 10.9356 9.44961 10.7957 9.44961 10.6232C9.44994 10.5399 9.41694 10.46 9.35797 10.4013C9.299 10.3425 9.21896 10.3099 9.13573 10.3105"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.13573 19.0642C8.96323 19.0649 8.82389 19.2052 8.82435 19.3777C8.82481 19.5502 8.9649 19.6897 9.13739 19.6895C9.30989 19.6892 9.44961 19.5493 9.44961 19.3768C9.44994 19.2936 9.41694 19.2137 9.35797 19.1549C9.299 19.0962 9.21896 19.0635 9.13573 19.0642"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowIcon = ({ color = "#323232" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 12H19"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7L5 12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 17L5 12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NoAppointmentIcon = () => (
  <svg
    width="121"
    height="124"
    viewBox="0 0 121 124"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="58.5" cy="51" rx="47.5" ry="48" fill="#EAEEF9" />
    <path
      d="M112.236 31.0882C114.491 31.0882 116.319 29.2443 116.319 26.9699C116.319 24.6954 114.491 22.8516 112.236 22.8516C109.981 22.8516 108.152 24.6954 108.152 26.9699C108.152 29.2443 109.981 31.0882 112.236 31.0882Z"
      fill="#EAEEF9"
    />
    <path
      d="M118.211 15.0156C119.751 15.0156 120.999 13.7564 120.999 12.2031C120.999 10.6498 119.751 9.39062 118.211 9.39062C116.67 9.39062 115.422 10.6498 115.422 12.2031C115.422 13.7564 116.67 15.0156 118.211 15.0156Z"
      fill="#EAEEF9"
    />
    <path
      d="M16.6731 10.4464C19.5334 10.4464 21.8521 8.10791 21.8521 5.22321C21.8521 2.33851 19.5334 0 16.6731 0C13.8129 0 11.4941 2.33851 11.4941 5.22321C11.4941 8.10791 13.8129 10.4464 16.6731 10.4464Z"
      fill="#EAEEF9"
    />
    <path
      d="M77.0764 24.7342H51.6846V15.0156H84.9693C85.0305 15.0156 85.0917 15.0156 85.1529 15.0156C90.3536 15.1394 94.5754 19.4726 94.5754 24.7342H83.5621"
      fill="#CCD4E2"
    />
    <g filter="url(#filter0_d_272_19623)">
      <path
        d="M85.8874 15.0156C83.9295 15.1394 82.094 15.9442 80.8091 17.306C80.6867 17.4298 80.5643 17.5536 80.442 17.7393C79.2794 19.1012 78.4229 20.8963 78.4229 22.8153V80.6317C78.4229 86.0172 74.1399 90.3503 68.8168 90.3503H22.0713V22.382C22.1937 20.4011 22.9279 18.6059 24.2128 17.306C25.62 15.8823 27.5168 15.0156 29.6583 15.0156H76.7097H85.6427C85.7039 15.0156 85.7651 15.0156 85.8874 15.0156Z"
        fill="url(#paint0_linear_272_19623)"
      />
    </g>
    <path
      d="M69.1213 28.2633H55.2322C54.7427 28.2633 54.3145 27.83 54.3145 27.3348C54.3145 26.8396 54.7427 26.4062 55.2322 26.4062H69.1213C69.6108 26.4062 70.0391 26.8396 70.0391 27.3348C70.0391 27.83 69.6719 28.2633 69.1213 28.2633Z"
      fill="#B3BFD3"
    />
    <path
      d="M48.6868 28.2633H30.576C30.0865 28.2633 29.6582 27.83 29.6582 27.3348C29.6582 26.8396 30.0865 26.4062 30.576 26.4062H48.748C49.2375 26.4062 49.6658 26.8396 49.6658 27.3348C49.6658 27.83 49.2375 28.2633 48.6868 28.2633Z"
      fill="#B3BFD3"
    />
    <path
      d="M60.3112 37.4235H42.2615C41.772 37.4235 41.3438 36.9902 41.3438 36.4949C41.3438 35.9997 41.772 35.5664 42.2615 35.5664H60.3112C60.8006 35.5664 61.2289 35.9997 61.2289 36.4949C61.2901 36.9902 60.8618 37.4235 60.3112 37.4235Z"
      fill="#B3BFD3"
    />
    <path
      d="M36.4498 37.4235H30.576C30.0865 37.4235 29.6582 36.9902 29.6582 36.4949C29.6582 35.9997 30.0865 35.5664 30.576 35.5664H36.4498C36.9392 35.5664 37.3675 35.9997 37.3675 36.4949C37.3675 36.9902 36.9392 37.4235 36.4498 37.4235Z"
      fill="#D4DBEC"
    />
    <path
      d="M69.1222 46.5875H58.0477C57.5582 46.5875 57.1299 46.1542 57.1299 45.659C57.1299 45.1638 57.5582 44.7305 58.0477 44.7305H69.1222C69.6117 44.7305 70.04 45.1638 70.04 45.659C70.04 46.1542 69.6729 46.5875 69.1222 46.5875Z"
      fill="#D4DBEC"
    />
    <path
      d="M52.725 46.5875H30.576C30.0865 46.5875 29.6582 46.1542 29.6582 45.659C29.6582 45.1638 30.0865 44.7305 30.576 44.7305H52.725C53.2145 44.7305 53.6428 45.1638 53.6428 45.659C53.6428 46.1542 53.2757 46.5875 52.725 46.5875Z"
      fill="#B3BFD3"
    />
    <path
      d="M60.3114 55.7477H48.1356C47.6461 55.7477 47.2178 55.3144 47.2178 54.8192C47.2178 54.3239 47.6461 53.8906 48.1356 53.8906H60.3114C60.8009 53.8906 61.2292 54.3239 61.2292 54.8192C61.2904 55.3144 60.8621 55.7477 60.3114 55.7477Z"
      fill="#B3BFD3"
    />
    <path
      d="M42.813 55.7477H30.576C30.0865 55.7477 29.6582 55.3144 29.6582 54.8192C29.6582 54.3239 30.0865 53.8906 30.576 53.8906H42.8742C43.3637 53.8906 43.792 54.3239 43.792 54.8192C43.792 55.3144 43.3637 55.7477 42.813 55.7477Z"
      fill="#D4DBEC"
    />
    <path
      d="M69.1217 64.9078H60.617C60.1275 64.9078 59.6992 64.4745 59.6992 63.9793C59.6992 63.4841 60.1275 63.0508 60.617 63.0508H69.1217C69.6112 63.0508 70.0395 63.4841 70.0395 63.9793C70.0395 64.4745 69.6724 64.9078 69.1217 64.9078Z"
      fill="#B3BFD3"
    />
    <path
      d="M55.1114 64.9078H40.8553C40.3658 64.9078 39.9375 64.4745 39.9375 63.9793C39.9375 63.4841 40.3658 63.0508 40.8553 63.0508H55.1114C55.6009 63.0508 56.0292 63.4841 56.0292 63.9793C56.0292 64.4745 55.6009 64.9078 55.1114 64.9078Z"
      fill="#D4DBEC"
    />
    <path
      d="M35.532 64.9078H30.576C30.0865 64.9078 29.6582 64.4745 29.6582 63.9793C29.6582 63.4841 30.0865 63.0508 30.576 63.0508H35.532C36.0215 63.0508 36.4498 63.4841 36.4498 63.9793C36.4498 64.4745 36.0215 64.9078 35.532 64.9078Z"
      fill="#B3BFD3"
    />
    <path
      d="M60.3115 74.0719H51.868C51.3785 74.0719 50.9502 73.6386 50.9502 73.1434C50.9502 72.6482 51.3785 72.2148 51.868 72.2148H60.3115C60.801 72.2148 61.2293 72.6482 61.2293 73.1434C61.2905 73.6386 60.8622 74.0719 60.3115 74.0719Z"
      fill="#B3BFD3"
    />
    <path
      d="M46.3006 74.0719H30.576C30.0865 74.0719 29.6582 73.6386 29.6582 73.1434C29.6582 72.6482 30.0865 72.2148 30.576 72.2148H46.3006C46.7901 72.2148 47.2184 72.6482 47.2184 73.1434C47.2184 73.6386 46.7901 74.0719 46.3006 74.0719Z"
      fill="#D4DBEC"
    />
    <path
      d="M48.2579 82.6758H60.6173C60.6173 84.7805 61.4739 86.6994 62.82 88.0613C64.1661 89.485 66.0628 90.2897 68.1431 90.2897H12.5258C10.4455 90.2897 8.54874 89.4231 7.20267 88.0613C5.85659 86.6994 5 84.7805 5 82.6758H41.5887C41.5887 82.6758 48.3803 82.7377 48.2579 82.6758Z"
      fill="#CCD4E2"
    />
    <path
      d="M101.318 76.747L93.5928 68.9619L95.3638 67.1758L103.083 74.967L101.318 76.747Z"
      fill="#858B9B"
    />
    <path
      d="M104.004 79.4835L98.08 73.5092C97.5853 73.0103 97.5853 72.1973 98.08 71.6984C98.5746 71.1995 99.3808 71.1995 99.8754 71.6984L105.799 77.6727C106.294 78.1716 106.294 78.9846 105.799 79.4835C105.305 79.9824 104.498 79.9824 104.004 79.4835Z"
      fill="#858B9B"
    />
    <path
      d="M103.582 79.8678L95.961 72.1813C95.7838 72.0027 95.7838 71.7132 95.961 71.5284L97.9091 69.5636C98.0862 69.385 98.3732 69.385 98.5564 69.5636L106.178 77.2502C106.355 77.4288 106.355 77.7183 106.178 77.9031L104.23 79.8678C104.047 80.0464 103.76 80.0464 103.582 79.8678Z"
      fill="url(#paint1_linear_272_19623)"
    />
    <path
      d="M84.8474 43.875C76.7617 43.875 70.209 50.4837 70.209 58.6384C70.209 66.7869 76.7617 73.4017 84.8413 73.4017C92.9269 73.4017 99.4796 66.793 99.4796 58.6384C99.4796 50.4837 92.9269 43.875 84.8474 43.875ZM84.8474 70.6671C78.3557 70.6671 73.0976 65.2779 73.0976 58.6322C73.0976 51.9865 78.3557 46.6035 84.8474 46.6035C91.3391 46.6035 96.5971 51.9927 96.5971 58.6384C96.5971 65.284 91.333 70.6671 84.8474 70.6671Z"
      fill="url(#paint2_linear_272_19623)"
    />
    <defs>
      <filter
        id="filter0_d_272_19623"
        x="0.0712891"
        y="4.01562"
        width="107.816"
        height="119.336"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_272_19623"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_272_19623"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_272_19623"
        x1="53.9586"
        y1="13.2731"
        x2="53.9586"
        y2="91.1625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_272_19623"
        x1="95.8233"
        y1="74.7169"
        x2="106.313"
        y2="74.7169"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_272_19623"
        x1="70.1956"
        y1="58.6416"
        x2="99.485"
        y2="58.6416"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);

const PlayStoreIcon = () => (
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M4.43069 0.61L17.5547 8.156L14.7417 10.969L4.43069 0.61ZM1.71169 0L13.7587 12L1.71269 24C1.09969 23.729 0.679688 23.126 0.679688 22.425C0.679688 22.402 0.679688 22.379 0.680688 22.357V22.36V1.641C0.679688 1.622 0.679688 1.599 0.679688 1.576C0.679688 0.875 1.09969 0.272 1.70169 0.005L1.71269 0.001L1.71169 0ZM21.6337 10.594C22.0477 10.901 22.3127 11.389 22.3127 11.938C22.3127 11.96 22.3127 11.981 22.3117 12.003V12C22.3157 12.043 22.3187 12.094 22.3187 12.145C22.3187 12.661 22.0687 13.119 21.6827 13.403L21.6787 13.406L18.8657 14.999L15.8197 12L18.8667 8.953L21.6337 10.594ZM4.43069 23.39L14.7427 13.031L17.5557 15.844L4.43069 23.39Z"
      fill="white"
    />
  </svg>
);

const AppleStoreIcon = () => (
  <svg
    width="21"
    height="26"
    viewBox="0 0 21 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="apple">
      <path
        id="Path"
        d="M7.21471 25.3078C3.67556 25.2867 0.748047 17.7779 0.748047 13.9539C0.748047 7.7074 5.25668 6.33987 6.99428 6.33987C7.77734 6.33987 8.61349 6.65947 9.35099 6.9423C9.86671 7.13958 10.4001 7.34324 10.6967 7.34324C10.8743 7.34324 11.2927 7.16999 11.6621 7.01798C12.45 6.69201 13.4303 6.28687 14.5719 6.28687C14.574 6.28687 14.5767 6.28687 14.5787 6.28687C15.4312 6.28687 18.0158 6.4813 19.5697 8.90665L19.9337 9.47515L19.4099 9.88598C18.6615 10.4729 17.296 11.5434 17.296 13.664C17.296 16.1757 18.8425 17.1416 19.5854 17.6061C19.9133 17.8112 20.2528 18.0226 20.2528 18.4851C20.2528 18.787 17.9342 25.2704 14.5672 25.2704C13.7433 25.2704 13.1609 25.013 12.6472 24.786C12.1275 24.5562 11.6791 24.3582 10.9382 24.3582C10.5626 24.3582 10.0877 24.5428 9.58498 24.7387C8.89792 25.0052 8.12024 25.3078 7.23784 25.3078H7.21471Z"
        fill="white"
      />
      <path
        id="Path_2"
        d="M15.375 0.692383C15.46 4.07846 13.2674 6.42756 11.0774 6.28023C10.7165 3.57803 13.2671 0.692383 15.375 0.692383Z"
        fill="white"
      />
    </g>
  </svg>
);

export {
  CancelledInstantIcon,
  DateIcon,
  UniqueIdIcon,
  ClockIcon,
  ChatIcon,
  Circles,
  HeartIcon,
  ArrowIcon,
  NoAppointmentIcon,
  PlayStoreIcon,
  AppleStoreIcon,
};
